import React from "react"
import { Box, Typography, Button, Container } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { useAuth } from "../../services/useAuth"
import { Icon, LogoFull, RowBox } from "../../components"
import { PublicContainer } from "../Master"

const useStyles = makeStyles(() => ({
  spinner: {
    height: "100vh",
  },
  container: {
    width: "100%",
  },
  root: {
    textAlign: "center",
  },
  buttonBox: {
    width: "100%",
  },
  button: {
    color: "#000000",
  },
}))

const LoginDevice = () => {
  const classes = useStyles()
  const { getDeviceLoginLink } = useAuth()

  const handleRetry = () => {
    window.location.reload(true)
  }

  const handleCancel = () => {
    window.location = getDeviceLoginLink()
  }

  return (
    <PublicContainer>
      <Container component="main" className={classes.root}>
        <Box pt={5} px={2}>
          <Box mb={3}>
            <LogoFull width="197" />
          </Box>

          <Typography paragraph align="center">
            <strong>Unable to connect</strong>
          </Typography>
          <Typography paragraph align="center">
            Please ensure you have an active internet connection and try again.
          </Typography>
          <RowBox mt={7} mb={5} className={classes.buttonBox}>
            <Button type="button" fullWidth size="large" className={classes.button} onClick={handleRetry}>
              <Icon name="retry" />
              <Box ml={1}>Retry</Box>
            </Button>
          </RowBox>
          <Button type="button" fullWidth size="large" className={classes.button} onClick={handleCancel}>
            <Icon name="back" />
            <Box ml={1}>Back</Box>
          </Button>
        </Box>
      </Container>
    </PublicContainer>
  )
}

export { LoginDevice }
